import { BigPictureClient, Configuration, Event, Service } from '@vimeo/bigpicture-client';
import { Viewer } from '@vimeo/viewer';

// Prevent other packages from overwriting the BigPictureClient config we set
const bigPictureClientConfig = BigPictureClient.configure;
BigPictureClient.configure = (...args: any[]) => void 0;

const getEnvironment = () => {
  const ciRegex = /\.ci\.vimeows.com$/;
  const environment = ciRegex.test(window.location.host)
    ? 'staging'
    : process.env.NODE_ENV === 'production'
    ? 'production'
    : 'development';

  return environment;
};

/**
 * Bootstrap the bigpicture client.
 */
export function bootstrapBigPicture(viewer: Viewer) {
  const { locale, vuid, ribbonModifier, user } = viewer;

  const flags = [];
  if (user?.capabilities?.hasEnterpriseLihp) {
    flags.push('has_video_library');
  }

  const bpFrontendContext = new Event('vimeo.web_global', 5, {
    user: {
      subscription_type: user?.account ?? null,
      is_mod: ribbonModifier === 'mod' || user?.badge.type === 'staff',
      session_id: null,
      teams: null,
      user_id: user?.id ?? null,
      vuid: vuid,
      flags,
      is_free_trial: false,
    },
    application: {
      application: 'vimeo',
      vimeo_language: locale,
      product: 'app_shell',
      build_environment: getEnvironment(),
      version: {
        full: '1.0.0',
        major: '1',
        minor: '0',
        patch: '0',
      },
    },
    platform: {
      device_language: window.navigator?.language ?? '',
      screen: {
        dpi: screen.pixelDepth,
        height: screen.height,
        width: screen.width,
        size: `${screen.width} x ${screen.height}`,
      },
      network: null,
      platform: 'web',
    },
  });

  bigPictureClientConfig(
    new Configuration(
      process.env.NODE_ENV === 'production' && !(getEnvironment() === 'staging')
        ? window.location.hostname === 'videoji.cn'
          ? Service.FRESNEL_PROD_CN
          : Service.FRESNEL_PROD
        : Service.FRESNEL_DEV,
      bpFrontendContext,
    ),
  );
}
